/**
 * MasterCancelReasons テーブルの category フィールド。
 * clinic 用と patient 用のキャンセル理由を区別する。
 */
export const CancelReasonCategory = {
    CLINIC: "clinic",
    PATIENT: "patient",
};
/**
 * 「その他」のキャンセル理由名。
 * この名前に一致する理由が選択された場合、詳細テキストの入力を必須にする。
 */
export const OTHER_CANCEL_REASON_NAME = "その他";
/**
 * patient 側のデフォルトキャンセル理由 ID。
 * アンケートをスキップした場合に使用する。
 * name は DB（MasterCancelReasons テーブル）から取得すること。
 */
export const DEFAULT_PATIENT_CANCEL_REASON_ID = "101";
/**
 * clinic 側のデフォルトキャンセル理由 ID。
 * name は DB（MasterCancelReasons テーブル）から取得すること。
 */
export const DEFAULT_CLINIC_CANCEL_REASON_ID = "1";
